import type { DetailedViolation } from "./types";

export type ViolationRange = {
  readonly startDay: number;
  readonly endDay: number;
};

export function getPatternName(pattern?: string): string {
  switch (pattern) {
    case "ED":
      return "E 다음 날 D";
    case "ND":
      return "N 다음 날 D";
    case "NE":
      return "N 다음 날 E";
    default:
      return "E 다음 날 D";
  }
}

export function getViolationRange(
  violation: DetailedViolation
): ViolationRange | null {
  switch (violation.type) {
    case "max_conseq_work":
    case "three_seq_nig":
      if (
        violation.start_day !== undefined &&
        violation.end_day !== undefined
      ) {
        return {
          startDay: violation.start_day,
          endDay: violation.end_day,
        };
      }
      return null;

    case "banned_day_after_eve":
      if (violation.day !== undefined && violation.next_day !== undefined) {
        return {
          startDay: violation.day,
          endDay: violation.next_day,
        };
      }
      return null;

    case "two_offs_after_two_nig":
      if (violation.start_day !== undefined) {
        return {
          startDay: violation.start_day,
          endDay:
            violation.off_end_day ??
            violation.end_day ??
            violation.start_day + 3,
        };
      }
      return null;

    case "two_offs_after_three_nig":
      if (violation.start_day !== undefined) {
        return {
          startDay: violation.start_day,
          endDay:
            violation.off_end_day ??
            violation.end_day ??
            violation.start_day + 4,
        };
      }
      return null;

    default:
      return null;
  }
}
